import { css, useTheme } from "@emotion/react";
import { useContext } from "react";

import cardComponentContext from "./cardComponentContext";
import parseStyle from "./parseStyle";
import useThemeProps from "./useThemeProps.jsx";

export default function CardContent(props) {
  props = useThemeProps({ props, name: "CardContent" });
  const theme = useTheme();
  let { children, style, rowGap = 3, ...restProps } = props;
  const {
    isHorizontal,
    mirrored,
    padding,
    stripPadding,
    hasImage,
    mediaColspan,
    horizontalContentMinWidth,
    horizontalContentMaxWidth,
    contentAlign = "center",
    mediaBelow,
  } = useContext(cardComponentContext);
  let colspan = 12 - mediaColspan;
  return (
    <div
      css={css`
        min-width: ${isHorizontal ? horizontalContentMinWidth : null};
        flex: ${colspan} ${colspan} 0;
        isolation: isolate;
        display: grid;
        justify-content: ${isHorizontal ? "center" : null};
        grid-template-columns: ${isHorizontal
          ? `minmax(0, ${theme.getLength(horizontalContentMaxWidth)})`
          : null};
        row-gap: ${theme.getLength(rowGap)};
        align-self: ${isHorizontal ? contentAlign : null};
        align-content: center;
        padding: ${stripPadding ? 0 : theme.getLength(padding)};
        padding-block-start: ${hasImage && !isHorizontal && !mediaBelow
          ? theme.getLength(padding)
          : null};
        padding-block-end: ${hasImage && !isHorizontal && mediaBelow
          ? theme.getLength(padding)
          : null};
        padding-inline-start: ${hasImage && isHorizontal && !mirrored
          ? theme.getLength(padding)
          : null};
        padding-inline-end: ${hasImage && isHorizontal && mirrored
          ? theme.getLength(padding)
          : null};
        .wsui-is-interactive {
          position: relative;
          z-index: 2;
        }
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {children}
    </div>
  );
}
